<template>
  <div id="app">
    <component :is="layout">
      <router-view/>
    </component>
  </div>
</template>
<script>
import axios from 'axios'
const layout = 'default'
export default {
  name: 'app',
  computed: {
    layout () {
      return (this.$route.meta.layout || layout) + '-layout'
    }
  },
  created () {
    // nothing defined here (when this.$route.path is other than "/")
    console.log(this.$route, this.$route.meta.layout)
  },
  updated () {
    // something defined here whatever the this.$route.path
    console.log(this.$route, this.$route.meta.layout)
  },
  mounted () {
    // console.log(localStorage.getItem('uid'))
    axios.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getaccountSetting')
      .then(response => {
        localStorage.setItem('account_image', response.data.results[0].ghost_logo)
      })
    axios.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getprofileImage' + '?' + 'uid' + '=' + localStorage.getItem('uid')
    )
      .then(response => {
        // console.log(response)
        localStorage.setItem('profile_img', response.data.results[0].profile_image)
      })
  }
}
</script>

<style>
  @import '/././node_modules/vue-vanilla-datetime-picker/dist/DateTimePicker';
  @import './assets/plugins/bootstrap/css/bootstrap.min.css';
  @import './assets/plugins/font-awesome/css/all.min.css';
  @import './assets/plugins/toastr/toastr.min.css';
  @import './assets/plugins/lime.min.css';
  @import './assets/plugins/custom.css';
  @import './assets/plugins/custom.css';
  @import './assets/plugins/custom.css';
  @import './assets/plugins/custom.css';
  @import 'https://fonts.googleapis.com/icon?family=Material+Icons'
</style>




// WEBPACK FOOTER //
// src/App.vue